export default __webpack_public_path__ + "static/media/open_up.0f5f6856.svg";